<template>
  <div class="slider-in-stock-section">
    <div class="main-description-title">
        <span>Nýir og nýlegir bílar á sérkjörum til afhendingar strax</span>
    </div>
    <div class="slider-in-stock__slider">
        <dealer-cars-slider v-if="cars.length" dealers carsInStock :scar="cars" :cat_id="'999'" class="slider-similar-cars" />
    </div>
  </div>
</template>

<script>
import DealerCarsSlider from "@/components/Dealers/DealerCarsSlider.vue";
export default {
  components: {
    DealerCarsSlider
  },
  props: {
    cars: {
      type: Array,
      default: () => []
    }
  }
}
</script>
